module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Bold.5fc6f12.woff";